import { render } from "./CardEvent.vue?vue&type=template&id=c57dfe94&scoped=true"
import script from "./CardEvent.vue?vue&type=script&lang=js"
export * from "./CardEvent.vue?vue&type=script&lang=js"

import "./CardEvent.vue?vue&type=style&index=0&id=c57dfe94&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c57dfe94"]])

export default __exports__